// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13zZ4","colBig":"styles_colBig__1mec_","colSmall":"styles_colSmall__2LnxE"};